<div class="bonus-main-container text">
  <div class="bonus-container">
    <div class="bonus-dropdown-header" (click)="toggleDropDown()">
      <div class="header-row-left up-title" style="flex: 1" *ngIf="bonusOnlineTracker1Result[0]?.RemaniningAmount == null">{{ 'Bonus' | t }}</div>
      <div class="bonus-header-content" *ngIf="bonusOnlineTracker1Result[0]?.RemaniningAmount != null">
        <div class="bonus-header-row">
          <div class="header-row-left up-title" *ngIf="bonusOnlineTracker1Result[0]?.RemaniningAmount != null">{{ 'Bonus' | t }}</div>
          <div class="header-row-right green" *ngIf="bonusOnlineTracker1Result[0]?.BonusStatus == 2 || bonusOnlineTracker1Result[0]?.BonusStatus == 1">
            {{ bonusOnlineTracker1Result[0]?.BonusAmount }} {{ this._UserHelper.customerUser.Symbol }}
          </div>
          <div class="header-row-right red" *ngIf="bonusOnlineTracker1Result[0]?.BonusStatus == 0">
            {{ bonusOnlineTracker1Result[0]?.BonusAmount }} {{ this._UserHelper.customerUser.Symbol }}
          </div>
        </div>
        <div class="bonus-header-row">
          <div class="header-row-left sub-title black" *ngIf="bonusOnlineTracker1Result[0].BonusStatus == 1">
            {{ bonusOnlineTracker1Result[0].RemaningDay }}
          </div>
          <div class="header-row-left sub-title red" *ngIf="bonusOnlineTracker1Result[0].BonusStatus == 0">
            {{ 'Bonus_Text2' | t }}
          </div>
          <div class="header-row-left sub-title green" *ngIf="bonusOnlineTracker1Result[0].BonusStatus == 2">
            {{ 'Bonus_Text1' | t }}
          </div>
        </div>
      </div>
      <div class="bonus-header-right-side">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (bonusDropDownIsOpen ? 'up' : 'down')"> </image-loader-utils>
      </div>
    </div>
    <div class="bonus-content-container" *ngIf="bonusDropDownIsOpen && bonusOnlineTracker1Result[0]?.BonusAmount != 0">
      <div class="bonus-info-row">
        <div class="bonus-info-row-left">Datum akzeptiert:</div>

        <div class="bonus-info-row-right">
          {{ bonusOnlineTracker1Result[0]?.BonusStartDate | dateFormat : 'dd-MM-yyyy' }}
        </div>
      </div>
      <div class="bonus-info-row">
        <div class="bonus-info-row-left">Ablaufdatum:</div>
        <div class="bonus-info-row-right">
          {{ bonusOnlineTracker1Result[0]?.BonusEndDate | dateFormat : 'dd-MM-yyyy' }}
        </div>
      </div>
      <div class="bonus-info-row">
        <div class="bonus-info-row-left">Mindestquote:</div>
        <div class="bonus-info-row-right">
          {{ bonusOnlineTracker1Result[0]?.MinOddValue | number : '1.2-2' }}
        </div>
      </div>
      <hr class="bonus-line" />

      <div class="bonus-info-row">
        <div class="bonus-info-row-left">Umsatzbedingungen:</div>
        <div class="bonus-info-row-right">{{ bonusOnlineTracker1Result[0]?.TotalAmount | number : '1.2-2' }} {{ this._UserHelper.customerUser.Symbol }}</div>
      </div>
      <div class="bonus-info-row">
        <div class="bonus-info-row-left">Umgesetzter Betrag:</div>
        <div class="bonus-info-row-right">{{ bonusOnlineTracker1Result[0]?.Amount | number : '1.2-2' }} {{ this._UserHelper.customerUser.Symbol }}</div>
      </div>
      <div class="bonus-info-row">
        <div class="bonus-info-row-left">Verbleibende Umsatzbedingungen:</div>
        <div class="bonus-info-row-right">
          {{ bonusOnlineTracker1Result[0]?.RemaniningAmount | number : '1.2-2' }}
          {{ this._UserHelper.customerUser.Symbol }}
        </div>
      </div>
      <progress style="width: 100%" id="determinate" value="{{ bonusOnlineTracker1Result[0]?.Amount }}" min="0" max="{{ bonusOnlineTracker1Result[0]?.TotalAmount }}">
        {{ bonusOnlineTracker1Result[0]?.Amount }}
      </progress>
    </div>
  </div>
</div>
